export interface TreeNode {
    id: number | string
    idParent?: number | string
    depth: number
    name: string
    value?: number
}

export interface TreeNodeWithChildren {
    id: number | string
    depth: number
    idParent?: number | string
    name: string
    value?: number
    children: TreeNodeWithChildren[]
}

function _flattenTree(tree: TreeNodeWithChildren[]):TreeNode[] {
    const flatTree = []; 

    for (const node of tree || []) {
        node.idParent = undefined;
        node.depth = 0;
        flatTree.push(node)

        for (const child1 of node.children || []) {
            child1.idParent = node.id;
            child1.depth = 1;
            flatTree.push(child1)

            for (const child2 of child1.children || []) {
                child2.idParent = child1.id;
                child2.depth = 2;
                flatTree.push(child2)

                for (const child3 of child2.children || []) {
                    child3.idParent = child2.id;
                    child3.depth = 3;
                    flatTree.push(child3)

                    for (const child4 of child3.children || []) {
                        child4.idParent = child3.id;
                        child4.depth = 4;
                        flatTree.push(child4)

                        for (const child5 of child4.children || []) {
                            child5.idParent = child4.id;
                            child5.depth = 5;
                            flatTree.push(child5)
                        }
                    }
                }
            }                
        }
    }

    for (const node of flatTree || []) {
        // @ts-ignore
        delete node.children
    }

    return flatTree;
}

export function flattenTree(tree: TreeNodeWithChildren[]):TreeNode[] {
    return _flattenTree(tree)
}
